import React from 'react';
import { Helmet } from 'react-helmet';

const SEO = ({
  title = 'Cosmelytix - Personalized Anti-Age Skincare & Beauty Recommendations',
  description = "Discover expert anti-age skincare and beauty product recommendations based on smart ingredient analysis. Find your perfect products with Cosmelytix.",
  url = 'https://cosmelytix.com',
  image = 'https://cosmelytix.com/assets/images/backgrounds/cosmelytix_share.png', // Or a more appropriate default image
  children
}) => {
  return (
    <Helmet>
      <meta charset="utf-8" />
      <title>{title}</title>
      <meta name="description" content={description} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />

      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={url} />
      <meta property="twitter:title" content={title} />
      <meta property="twitter:description" content={description} />
      <meta property="twitter:image" content={image} />


      <link rel="icon" type="image/x-icon" href="/assets/favicon.ico" />
      <link rel="icon" type="image/png" href="/assets/favicon-196x196.png" sizes="196x196" />
      <link rel="icon" type="image/png" href="/assets/favicon-128x128.png" sizes="128x128" />
      <link rel="icon" type="image/png" href="/assets/favicon-96x96.png" sizes="96x96" />
      <link rel="icon" type="image/png" href="/assets/favicon-32x32.png" sizes="32x32" />
      <link rel="icon" type="image/png" href="/assets/favicon-16x16.png" sizes="16x16" />
      <link rel="manifest" href="/site.webmanifest" />
      <link rel="apple-touch-icon" href="/apple-touch-icon.png" />



      {children}
    </Helmet>
  );
};

export default SEO;